import { GiftCard } from '../../../redux/types';
import { ComponentView } from '../../../types/types';

interface ValidateParams {
  secondaryMethod: string;
  amountToPay: number;
  method: string;
  component: ComponentView;
  giftCard: GiftCard;
}

export const validatePayment = (params: ValidateParams): boolean => {
  if (!params.method) {
    return false;
  }

  if (params.amountToPay > 0) {
    if (params.method === 'giftcard') {
      if (params.component === ComponentView.Checkout) {
        if (!params.giftCard) {
          return true; // validate method not options in this case
        }

        // giftcard covers whole sum
        if (params.giftCard.remainingAmount > 0) {
          return true;
        }

        // giftcard doesn't cover whole sum
        if (!params.secondaryMethod) {
          return false;
        }
      }
    }

    return true;
  }

  return true;
};
